

$(document).ready(function() {
    function updateDeliveryInfo() {
        var currentTime = new Date();
        var currentHour = currentTime.getHours();
        var currentMinute = currentTime.getMinutes();
        var currentSecond = currentTime.getSeconds();
        var currentDay = currentTime.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
        
        // Adjusting 00:00 to 23:59
        if (currentHour === 0 && currentMinute === 0 && currentSecond === 0) {
            currentHour = 23;
            currentMinute = 59;
            currentSecond = 59;
        }
        
        var deliveryMessage = "";
        var cutoffTime;

        if (currentDay !== 5) { // For days other than Friday
            if (currentHour < 9 || (currentHour === 9 && currentMinute <= 45)) {
                cutoffTime = "09:45";
                deliveryMessage = "Get It By Today 1 PM";
            } else if (currentHour < 12 || (currentHour === 12 && currentMinute <= 45)) {
                cutoffTime = "12:45";
                deliveryMessage = "Get It By Today 4 PM";
            } else if (currentHour < 15 || (currentHour === 15 && currentMinute <= 45)) {
                cutoffTime = "15:45";
                deliveryMessage = "Get It By Today 7 PM";
            } else if (currentHour < 18 || (currentHour === 18 && currentMinute <= 45)) {
                cutoffTime = "18:45";
                deliveryMessage = "Get It By Today 10 PM";
            } else {
                cutoffTime = "23:59";
                deliveryMessage = "Get It By Tomorrow 1 PM";
            }
        } else { // For Friday
            if (currentHour < 14 || (currentHour === 14 && currentMinute === 0)) {
                cutoffTime = "14:00";
                deliveryMessage = "Get it by Today";
            } else {
                cutoffTime = "23:59";
                deliveryMessage = "Get it tomorrow by 1 PM";
            }
        }

        if (deliveryMessage !== "") {
            var cutoffHour = parseInt(cutoffTime.split(":")[0]);
            var cutoffMinute = parseInt(cutoffTime.split(":")[1]);
            var remainingHours = cutoffHour - currentHour;
            var remainingMinutes = cutoffMinute - currentMinute;
            var remainingSeconds = 60 - currentSecond;
            
            if (remainingSeconds === 60) {
                remainingSeconds = 0;
                remainingMinutes++;
            }
            
            if (remainingMinutes < 0) {
                remainingHours--;
                remainingMinutes += 60;
            }
            
            if (remainingHours < 0) {
                remainingHours += 24;
            }

            var text_hour = (remainingHours === 1) ? "hour" : "hours";
            var text_mins = (remainingMinutes === 1) ? "min" : "mins";

            // Ensure the elements are present before updating them
            if ($('.get_in_by_text').length && $('.delivery_text').length) {
                $('.get_in_by_text').text(deliveryMessage);
                $('.delivery_text').text(remainingHours + " " + text_hour + " " + remainingMinutes + ' ' + text_mins);
            }
        }
    }

    // Update delivery info initially
    updateDeliveryInfo();
    
    // Update delivery info every minute
    setInterval(updateDeliveryInfo, 600);

    // Add event listener for hover_button class to trigger the function
    $(document).on("click", ".hover_button a", function() {
        // Try to update immediately and also ensure elements are available
        updateDeliveryInfo();
    });
});


